define('AwaLabs.LoyaltyClubLink', [
    'SC.Configuration',
    'Backbone'
], function AwaLabsLoyaltyClubLink(
    Configuration
) {
    'use strict';
    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            if (layout) {
                layout.addToViewContextDefinition('Header.Menu.View', 'loyaltyURL', 'string', function fn() {
                    return Configuration.get('LoyaltyClubLinkUrl');
                });
                layout.addToViewContextDefinition('Header.Menu.View', 'loyaltyText', 'string', function fn() {
                    return Configuration.get('LoyaltyClubLinkText');
                });
                layout.addToViewContextDefinition('Header.View', 'loyaltyURL', 'string', function fn() {
                    return Configuration.get('LoyaltyClubLinkUrl');
                });
                layout.addToViewContextDefinition('Header.View', 'loyaltyText', 'string', function fn() {
                    return Configuration.get('LoyaltyClubLinkText');
                });
            }
        }
    };
});
